module.exports = __webpack_public_path__ + "static/media/Avatar_19.15501b77.svg";